import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import {
  Button,
  Autocomplete,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  MenuItem,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as Yup from "yup";
import {
  ApiGetClientEntities,
  ApiGetClientEntitiTemplate,
  ApiGetVisitTimes,
  ApiPostClientEntityTemplate,
  ApiPostVisitTimes,
  ApiPutClientEntityTemplate,
} from "../../../apiService/Core/Apicall.tsx";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import {
  visitDaysOptions,
  genderOptions,
  jobTimeTypeOptions,
} from "../../../global/constants/globalContants.ts";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../global/config/Action/loadingActions.ts";
import imageCompression from "browser-image-compression";
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx";
import store from "../../../global/config/store.ts";

interface ViewJobCriteriaBusinessProps {
  onSubmit: (values: any) => void;
}

interface Business {
  label: string;
  value: string;
}

const ViewJobCriteriaBusiness: React.FC<ViewJobCriteriaBusinessProps> = ({
  onSubmit,
}) => {
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [templateData, setTemplateData] = useState<any>();
  const location = useLocation();
  const navigate = useNavigate();
  // const business = location?.state?.store;
  const { id } = useParams()
  const [clientEntityId, setClientEntityId] = useState(
    id
  );
  const [visitTimes, setVisitTimes] = useState<any>([]);
  const [regionVisitTimeArray, setRegionVisitTimeArray] = useState<number[]>([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [reportCategoryLogoUrl, setReportCategoryLogoUrl] = useState("");
  const [expanded, setExpanded] = useState<string | false>(false);

  console.log("visitTimes", visitTimes);
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const data = `?clientEntityId=${id}`;
        try {
          const response = await ApiGetClientEntitiTemplate(data);
          console.log("Fetched Client Template Data:", response.data);
          setTemplateData(response.data[0]); // business data in state
          setReportCategoryLogoUrl(response.data[0].reportCategoryLogo);
          if (response.data[0].regionVisitTimeInformation) {
            const regionTimes = response.data[0].regionVisitTimeInformation
              .split(",")
              .map((time: string) => parseInt(time.trim()));
            setRegionVisitTimeArray(regionTimes);
          }
        } catch (error) {
          console.error("Error fetching client entity template:", error);
        }
      }
      await handleGetVisitTimeList();
    };
    fetchData();
  }, [id]);
  console.log(templateData);
  console.log("clientENtity Id --->", clientEntityId);

  const handleGetVisitTimeList = async () => {
    try {
      const response: any = await ApiGetVisitTimes();
      setVisitTimes(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    const handleGetClientList = async () => {
      const data = "?offset=0&limit=100&clientEntityStatus=active";
      try {
        const response: any = await ApiGetClientEntities(data);
        const transformedData = response.data.map((item: any) => ({
          value: item.clientEntityId,
          label: item.entityName,
        }));
        setBusinesses(transformedData);
      } catch (error) {
        console.error("Error during API call:", error);
      }
    };

    handleGetClientList();
  }, []);

  const validationSchema = Yup.object({
    business: Yup.string().required("Please select a business"),
    jobTimeType: Yup.string().required("Please select a job time type"),
    visitDays: Yup.array()
      .min(1, "Please select at least one visit day")
      .required("Visit days are required"),
    visitTimes: Yup.array()
      .min(1, "Please select at least one visit time")
      .required("Visit times are required"),
    minAge: Yup.number()
      .typeError("Min Age must be a number")
      .positive("Min Age must be a positive number")
      .integer("Min Age must be an integer")
      //.min(18, "Min Age must be at least 18") // Minimum value of 18
      .max(100, "Min Age cannot be more than 100") // Limit input to 100
      .required("Min Age is required"),
    maxAge: Yup.number()
      .typeError("Max Age must be a number")
      .positive("Max Age must be a positive number")
      .integer("Max Age must be an integer")
      .required("Max Age is required")
      .min(
        Yup.ref("minAge"),
        "Max Age must be greater than or equal to Min Age"
      ) //  Must be greater than minAge
      .max(100, "Max Age cannot be more than 100"), // imit input to 100
    gender: Yup.string().required("Please select a gender"),
    fromDate: Yup.date().required("From Date is required"),
    toDate: Yup.date()
      .required("To Date is required")
      .min(Yup.ref("fromDate"), "To Date must be after From Date"),
    //minDaysGapBetweenJobs: Yup.string().required()
    regionVisitDays: Yup.array(),
    regionVisitTimes: Yup.array(),
    regionFromDate: Yup.date(),
    regionToDate: Yup.date()
      .min(Yup.ref("regionFromDate"), "Region To Date must be after Region From Date"),
  });

  const handleSubmit = async (values: any) => {
    if (templateData) {
      const data = {
        clientEntityTemplateId: templateData.clientEntityTemplateId,
        clientEntityId: clientEntityId,
        jobTimeType: values.jobTimeType,
        repetitionCount: values.repetitionCount,
        visitDaysInformation: values.visitDays
          ? values.visitDays.join(", ")
          : "",
        visitTimeInformation: values.visitTimes
          ? values.visitTimes.join(", ")
          : "",
        minAge: values.minAge,
        maxAge: values.maxAge,
        gender: values.gender,
        minDate: moment(values.fromDate, "YYYY-MM-DD").format("DD"),
        maxDate: moment(values.toDate, "YYYY-MM-DD").format("DD"),
        minDaysGapBetweenJobs: values.minDaysGapBetweenJobs,
        repeatCountPerMonth: values.repeatCountPerMonth,
        shouldBeDifferentDayFromPreviousMonth:
          values.shouldBeDifferentDayFromPreviousMonth === "true",
        maxConsecutiveWeekendDays: values.maxConsecutiveWeekendDays,
        maxConsecutiveNonWeekendDays: values.maxConsecutiveNonWeekendDays,
        isNeedToBuyAlcohol: values.isNeedToBuyAlcohol === "true",
        shopperNotSeeJobForMonth: values.shopperNotSeeJobForMonth,
        isSmokingArea: values.isSmokingArea === "true",
        isNeedToDoGambling: values.isNeedToDoGambling === "true",
        reportCategoryLogo: reportCategoryLogoUrl,
        reportSubmissionTiming: values.reportSubmissionTiming,
        modifiedBy: Number(localStorage.getItem("createdBy")),
        regionVisitDaysInformation: values.regionVisitDays
          ? values.regionVisitDays.join(", ")
          : "",
        regionVisitTimeInformation: values.regionVisitTimes
          ? values.regionVisitTimes.join(", ")
          : "",
        regionMinDate: values.regionFromDate
          ? moment(values.regionFromDate, "YYYY-MM-DD").format("DD")
          : "",
        regionMaxDate: values.regionToDate
          ? moment(values.regionToDate, "YYYY-MM-DD").format("DD")
          : "",
        notes: values.notes ? values?.notes : ""
      };
      try {
        console.log("clientitytemplate payload", data);
        const response: any = await ApiPutClientEntityTemplate(data);
        toast.success("Criteria updated successfully!");
        navigate(-1);
      } catch (error) {
        console.error("Error during API call:", error);
      }
    } else {
      const data = {
        clientEntityId: clientEntityId,
        jobTimeType: values.jobTimeType,
        repetitionCount: values.repetitionCount,
        visitDaysInformation: values.visitDays
          ? values.visitDays.join(", ")
          : "",
        visitTimeInformation: values.visitTimes
          ? values.visitTimes.join(", ")
          : "",
        minAge: values.minAge,
        maxAge: values.maxAge,
        gender: values.gender,
        minDate: moment(values.fromDate, "YYYY-MM-DD").format("DD"),
        maxDate: moment(values.toDate, "YYYY-MM-DD").format("DD"),
        minDaysGapBetweenJobs: values.minDaysGapBetweenJobs,
        repeatCountPerMonth: values.repeatCountPerMonth,
        shouldBeDifferentDayFromPreviousMonth:
          values.shouldBeDifferentDayFromPreviousMonth === "true",
        maxConsecutiveWeekendDays: values.maxConsecutiveWeekendDays,
        maxConsecutiveNonWeekendDays: values.maxConsecutiveNonWeekendDays,
        isNeedToBuyAlcohol: values.isNeedToBuyAlcohol === "true",
        shopperNotSeeJobForMonth: values.shopperNotSeeJobForMonth,
        isSmokingArea: values.isSmokingArea === "true",
        isNeedToDoGambling: values.isNeedToDoGambling === "true",
        reportCategoryLogo: reportCategoryLogoUrl,
        reportSubmissionTiming: values.reportSubmissionTiming,
        createdBy: Number(localStorage.getItem("createdBy")),
        regionVisitDaysInformation: values.regionVisitDays
          ? values.regionVisitDays.join(", ")
          : "",
        regionVisitTimeInformation: values.regionVisitTimes
          ? values.regionVisitTimes.join(", ")
          : "",
        regionMinDate: values.regionFromDate
          ? moment(values.regionFromDate, "YYYY-MM-DD").format("DD")
          : "",
        regionMaxDate: values.regionToDate
          ? moment(values.regionToDate, "YYYY-MM-DD").format("DD")
          : "",
        notes: values.notes ? values?.notes : ""
      };

      try {
        console.log("clientitytemplate payload", data);
        const response: any = await ApiPostClientEntityTemplate(data);
        toast.success("Criteria Added successfully!");
        navigate(-1);
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }
  };
  const visitTimeArray = templateData?.visitTimeInformation
    ? templateData.visitTimeInformation.split(",").map(Number)
    : [];

  const uploadReportCategoryLogo = async (file: File) => {
    store.dispatch(setLoadingTrue());
    console.log("Report Logo File", file);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileType", "report_category_logo");
    if (clientEntityId) {
      formData.append("clientEntityId", clientEntityId);
    }
    console.log("file", file);
    formData.forEach((value, key) => {
      console.log(key, value);
    });

    try {
      const response = await CustomUploadProfilePic(formData);
      store.dispatch(setLoadingFalse());
      toast.success("Report category logo uploaded successfully");
      setReportCategoryLogoUrl(response.location);
    } catch (error) {
      console.error("Error uploading report logo:", error);
      toast.error(error);
    }
  };

  const handleReportCategoryLogoChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      store.dispatch(setLoadingTrue());
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        const fileReader = new FileReader();
        // fileReader.onloadend = () => {
        //   setReportLogoPreview(fileReader.result as string)
        // }
        fileReader.readAsDataURL(compressedFile);
        uploadReportCategoryLogo(compressedFile);
      } catch (error) {
        console.error("Report logo compression failed:", error);
      }
    }
  };

  const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{
        business: clientEntityId,
        repetitionCount: templateData?.repetitionCount || "",
        jobTimeType: templateData?.jobTimeType || "",
        visitDays: templateData?.visitDaysInformation
          ? templateData.visitDaysInformation
            .split(",")
            .map((day) => day.trim()) // Trim extra spaces
          : [],
        visitTimes: visitTimeArray || [],
        minAge: templateData?.minAge || "",
        maxAge: templateData?.maxAge || "",
        gender: templateData?.gender || "",
        fromDate:
          moment(templateData?.minDate, "DD").format("YYYY-MM-DD") || "",
        toDate: moment(templateData?.maxDate, "DD").format("YYYY-MM-DD") || "",
        minDaysGapBetweenJobs: templateData?.minDaysGapBetweenJobs || "",
        repeatCountPerMonth: templateData?.repeatCountPerMonth || "",
        shouldBeDifferentDayFromPreviousMonth:
          String(templateData?.shouldBeDifferentDayFromPreviousMonth) || "",
        maxConsecutiveWeekendDays:
          templateData?.maxConsecutiveWeekendDays || "",
        maxConsecutiveNonWeekendDays:
          templateData?.maxConsecutiveNonWeekendDays || "",
        isNeedToBuyAlcohol: String(templateData?.isNeedToBuyAlcohol) || "",
        shopperNotSeeJobForMonth: templateData?.shopperNotSeeJobForMonth || "",
        isSmokingArea: String(templateData?.isSmokingArea) || "",
        isNeedToDoGambling: String(templateData?.isNeedToDoGambling) || "",
        reportSubmissionTiming: String(templateData?.reportSubmissionTiming) || "",
        regionVisitDays: templateData?.regionVisitDaysInformation
          ? templateData.regionVisitDaysInformation
            .split(",")
            .map((day: string) => day.trim())
          : [],
        regionVisitTimes: regionVisitTimeArray || [],
        regionFromDate: templateData?.regionMinDate
          ? moment(templateData.regionMinDate, "DD").format("YYYY-MM-DD")
          : "",
        regionToDate: templateData?.regionMaxDate
          ? moment(templateData.regionMaxDate, "DD").format("YYYY-MM-DD")
          : "",
        notes: templateData?.notes || ""
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ values, setFieldValue, errors, touched }) => (
        <Form style={{ background: "white", padding: "30px" }}>
          <h1 className="common-add">View Job Criteria for Business</h1>

          <div
            className="form-group"
            style={{ display: "flex", gap: "20px", alignItems: "center" }}
          >
            {/* Business Selector */}
            <div style={{ flex: 1 }}>
              <Autocomplete
                options={businesses}
                value={
                  businesses.find(
                    (option) => option.value == values.business
                  ) || null
                }
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                  setFieldValue("business", newValue ? newValue.value : "");
                }}
                disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Business"
                    fullWidth
                    error={touched.business && Boolean(errors.business)}
                    helperText={touched.business && errors.business}
                  />
                )}
              />
            </div>

            {/* Job Time Type Selector */}
            <div style={{ flex: 1 }}>
              <Autocomplete
                options={jobTimeTypeOptions}
                value={
                  jobTimeTypeOptions.find(
                    (option) => option.value === values.jobTimeType
                  ) || null
                }
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                  setFieldValue("jobTimeType", newValue ? newValue.value : "");
                  setFieldValue("repetitionCount", "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Job Time Type"
                    fullWidth
                    error={touched.jobTimeType && Boolean(errors.jobTimeType)}
                    helperText={touched.jobTimeType && errors.jobTimeType}
                  />
                )}
              />
            </div>

            {values.jobTimeType && (
              <div style={{ flex: 1 }}>
                <TextField
                  label={
                    values.jobTimeType === "Monthly"
                      ? "Repetition count every month"
                      : values.jobTimeType === "Fortnightly"
                        ? "Repetition count every fortnight"
                        : ""
                  }
                  type="number"
                  fullWidth
                  value={values.repetitionCount || ""}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (/^\d*$/.test(value)) {
                      setFieldValue("repetitionCount", value);
                    }
                  }}
                  error={
                    touched.repetitionCount && Boolean(errors.repetitionCount)
                  }
                  helperText={touched.repetitionCount && errors.repetitionCount}
                />
              </div>
            )}
          </div>

          <Box className='extra' style={{ marginTop: "20px" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>Metro Business Criteria:</Typography>
            <Accordion
              className="border"
              expanded={expanded === 'metro'}
              onChange={handleAccordionChange('metro')}
              sx={{ mb: 3 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Metro</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {/* Visit Days Checkbox Group */}
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <label>Visit Days Information</label>
                  <FormGroup
                    style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                  >
                    {visitDaysOptions.map((day) => (
                      <FormControlLabel
                        key={day.value}
                        control={
                          <Checkbox
                            sx={{
                              '&.MuiCheckbox-root.Mui-checked': {
                                color: '#1976d2 !important',
                              }
                            }}
                            checked={values.visitDays.includes(day.value)}
                            onChange={(event) => {
                              const newVisitDays = event.target.checked
                                ? [...values.visitDays, day.value]
                                : values.visitDays.filter((val) => val !== day.value);
                              setFieldValue("visitDays", newVisitDays);
                            }}
                          />
                        }
                        label={day.label}
                      />
                    ))}
                  </FormGroup>
                  {touched.visitDays && errors.visitDays && (
                    <div style={{ color: "red", marginTop: "5px" }}>
                      {errors.visitDays}
                    </div>
                  )}
                </div>

                {/* Visit Time Checkbox Group */}
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <label>Visit Time Information</label>
                  <FormGroup
                    style={{ display: "flex", flexDirection: "row", gap: "10px", }}
                  >
                    {visitTimes.map((time) => (
                      <FormControlLabel
                        sx={{ flex: '0 0 30%' }}
                        key={time.visitTimeId}
                        control={
                          <Checkbox
                            sx={{
                              '&.MuiCheckbox-root.Mui-checked': {
                                color: '#1976d2 !important',
                              }
                            }}
                            checked={values.visitTimes.includes(time.visitTimeId)}
                            onChange={(event) => {
                              const newVisitTimes = event.target.checked
                                ? [...values.visitTimes, time.visitTimeId]
                                : values.visitTimes.filter(
                                  (val) => val !== time.visitTimeId
                                );
                              setFieldValue("visitTimes", newVisitTimes);
                              console.log("15555", values.visitTimes);
                            }}
                          />
                        }
                        label={time.visitTimeInformation}
                      />
                    ))}
                  </FormGroup>
                  {touched.visitTimes && errors.visitTimes && (
                    <div style={{ color: "red", marginTop: "5px" }}>
                      {errors.visitTimes}
                    </div>
                  )}
                </div>

                {/* From Date Field */}
                <div
                  className="form-group"
                  style={{ marginTop: "20px", display: "flex", gap: "20px" }}
                >
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="From Date"
                      type="date"
                      InputLabelProps={{ shrink: false }}
                      value={values.fromDate}
                      onChange={(e) => setFieldValue("fromDate", e.target.value)}
                      error={touched.fromDate && Boolean(errors.fromDate)}
                      helperText={touched.fromDate && errors.fromDate}
                    />
                  </div>

                  {/* To Date Field */}
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="To Date"
                      type="date"
                      InputLabelProps={{ shrink: false }}
                      value={values.toDate}
                      onChange={(e) => setFieldValue("toDate", e.target.value)}
                      error={touched.toDate && Boolean(errors.toDate)}
                      helperText={touched.toDate && errors.toDate}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>Regional Business Criteria:</Typography>
            <Accordion
              className="border"
              expanded={expanded === 'regional'}
              onChange={handleAccordionChange('regional')}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Regional</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {/* Visit Days Checkbox Group */}
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <label>Visit Days Information</label>
                  <FormGroup
                    style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                  >
                    {visitDaysOptions.map((day) => (
                      <FormControlLabel
                        key={day.value}
                        control={
                          <Checkbox
                            sx={{
                              '&.MuiCheckbox-root.Mui-checked': {
                                color: '#1976d2 !important',
                              }
                            }}
                            checked={values.regionVisitDays.includes(day.value)}
                            onChange={(event) => {
                              const newVisitDays = event.target.checked
                                ? [...values.regionVisitDays, day.value]
                                : values.regionVisitDays.filter((val) => val !== day.value);
                              setFieldValue("regionVisitDays", newVisitDays);
                            }}
                          />
                        }
                        label={day.label}
                      />
                    ))}
                  </FormGroup>
                </div>

                {/* Visit Time Checkbox Group */}
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <label>Visit Time Information</label>
                  <FormGroup
                    style={{ display: "flex", flexDirection: "row", gap: "10px", }}
                  >
                    {visitTimes.map((time) => (
                      <FormControlLabel
                        sx={{ flex: '0 0 30%' }}
                        key={time.visitTimeId}
                        control={
                          <Checkbox
                            sx={{
                              '&.MuiCheckbox-root.Mui-checked': {
                                color: '#1976d2 !important',
                              }
                            }}
                            checked={values.regionVisitTimes.includes(time.visitTimeId)}
                            onChange={(event) => {
                              const newVisitTimes = event.target.checked
                                ? [...values.regionVisitTimes, time.visitTimeId]
                                : values.regionVisitTimes.filter(
                                  (val) => val !== time.visitTimeId
                                );
                              setFieldValue("regionVisitTimes", newVisitTimes);
                            }}
                          />
                        }
                        label={time.visitTimeInformation}
                      />
                    ))}
                  </FormGroup>
                </div>

                {/* From Date Field */}
                <div
                  className="form-group"
                  style={{ marginTop: "20px", display: "flex", gap: "20px" }}
                >
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="From Date"
                      type="date"
                      InputLabelProps={{ shrink: false }}
                      value={values.regionFromDate}
                      onChange={(e) => setFieldValue("regionFromDate", e.target.value)}
                    />
                  </div>

                  {/* To Date Field */}
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="To Date"
                      type="date"
                      InputLabelProps={{ shrink: false }}
                      value={values.regionToDate}
                      onChange={(e) => setFieldValue("regionToDate", e.target.value)}
                    />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Box>

          {/* Min Age and Max Age Fields Side by Side */}
          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            {/* Min Age Field */}
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                label="Min Age"
                type="number"
                value={values.minAge}
                onChange={(e) => setFieldValue("minAge", e.target.value)}
                error={touched.minAge && Boolean(errors.minAge)}
                helperText={touched.minAge && errors.minAge}
              />
            </div>

            {/* Max Age Field */}
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                label="Max Age"
                type="number"
                value={values.maxAge}
                onChange={(e) => setFieldValue("maxAge", e.target.value)}
                error={touched.maxAge && Boolean(errors.maxAge)}
                helperText={touched.maxAge && errors.maxAge}
              />
            </div>

            <div style={{ flex: 1 }}>
              <Autocomplete
                options={genderOptions}
                value={
                  genderOptions.find(
                    (option) => option.value === values.gender
                  ) || null
                }
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                  setFieldValue("gender", newValue ? newValue.value : "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Gender"
                    fullWidth
                    error={touched.gender && Boolean(errors.gender)}
                    helperText={touched.gender && errors.gender}
                  />
                )}
              />
            </div>
          </div>

          {/* Block shopper */}
          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                select
                label="Block Shopper for doing job consecutively"
                value={values.shopperNotSeeJobForMonth}
                onChange={(e) =>
                  setFieldValue(
                    "shopperNotSeeJobForMonth",
                    Number(e.target.value)
                  )
                }
              >
                {[...Array(13)].map((_, i) => (
                  <MenuItem key={i} value={i}>
                    {i}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                select
                label="Min days gap between jobs"
                value={values.minDaysGapBetweenJobs}
                onChange={(e) =>
                  setFieldValue("minDaysGapBetweenJobs", Number(e.target.value))
                }
              >
                {[...Array(20)].map((_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {i + 1}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                label={
                  values.jobTimeType === "Monthly"
                    ? "No of jobs per month"
                    : values.jobTimeType === "Fortnightly"
                      ? "No of jobs per fortnight"
                      : "No of jobs per month"
                }
                type="number"
                value={values.repeatCountPerMonth}
                onChange={(e) =>
                  setFieldValue("repeatCountPerMonth", e.target.value)
                }
                inputProps={{ min: 1 }}
              // error={touched.minDaysGapBetweenJobs && Boolean(errors.minDaysGapBetweenJobs)}
              // helperText={touched.minDaysGapBetweenJobs && errors.minDaysGapBetweenJobs}
              />
            </div>
          </div>

          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <div style={{ flex: 1 }}>
              <FormControl fullWidth>
                <FormLabel>
                  Should be different day from previous month
                </FormLabel>
                <RadioGroup
                  row
                  value={values.shouldBeDifferentDayFromPreviousMonth}
                  onChange={(e) =>
                    setFieldValue(
                      "shouldBeDifferentDayFromPreviousMonth",
                      e.target.value
                    )
                  }
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div style={{ flex: 1 }}>
              {/* <TextField
                  fullWidth
                  label="Max Consecutive Weekend Days"
                  type="number"
                  value={values.maxConsecutiveWeekendDays}
                  onChange={(e) => setFieldValue("maxConsecutiveWeekendDays", e.target.value)}
                /> */}
              <TextField
                fullWidth
                label="Max Consecutive Weekend Days"
                type="number"
                value={values.maxConsecutiveWeekendDays}
                onChange={(e) =>
                  setFieldValue("maxConsecutiveWeekendDays", e.target.value)
                }
                inputProps={{ min: 1 }}
              />
            </div>
            <div style={{ flex: 1 }}>
              {/* <TextField
                  fullWidth
                  label="Max Consecutive Weekend Days"
                  type="number"
                  value={values.maxConsecutiveWeekendDays}
                  onChange={(e) => setFieldValue("maxConsecutiveWeekendDays", e.target.value)}
                /> */}
              <TextField
                fullWidth
                label="Max Consecutive Week Days"
                type="number"
                value={values.maxConsecutiveNonWeekendDays}
                onChange={(e) =>
                  setFieldValue("maxConsecutiveNonWeekendDays", e.target.value)
                }
                inputProps={{ min: 1 }}
              />
            </div>
          </div>

          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <div style={{ flex: 1 }}>
              <FormControl fullWidth>
                <FormLabel>Do they need to buy Alcohol?</FormLabel>
                <RadioGroup
                  row
                  value={values.isNeedToBuyAlcohol}
                  onChange={(e) =>
                    setFieldValue("isNeedToBuyAlcohol", e.target.value)
                  }
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div style={{ flex: 1 }}>
              <FormControl fullWidth>
                <FormLabel>Do they need to go to smoking area?</FormLabel>
                <RadioGroup
                  row
                  value={values.isSmokingArea}
                  onChange={(e) =>
                    setFieldValue("isSmokingArea", e.target.value)
                  }
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div style={{ flex: 1 }}>
              <FormControl fullWidth>
                <FormLabel>Do they need to do Gambling?</FormLabel>
                <RadioGroup
                  row
                  value={values.isNeedToDoGambling}
                  onChange={(e) =>
                    setFieldValue("isNeedToDoGambling", e.target.value)
                  }
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                select
                label="Report Submission Timing"
                value={values.reportSubmissionTiming}
                onChange={(e) =>
                  setFieldValue("reportSubmissionTiming", e.target.value)
                }
              >
                <MenuItem value="SAME_DAY">8 PM</MenuItem>
                <MenuItem value="WITHIN_24_HOURS">24 Hours</MenuItem>
              </TextField>
            </div>
          </div>
          <div
            className="form-group"
            style={{ marginTop: "20px", display: "flex", gap: "20px" }}
          >
            <div style={{ flex: 1 }}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Notes"
                name="notes"
                value={values.notes}
                onChange={(e) => setFieldValue("notes", e.target.value)}
                placeholder="Enter notes here..."
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "15px",
              width: "100%",
            }}
          >
            <label
              htmlFor="reportLogo"
              style={{
                marginRight: "10px",
                minWidth: "200px",
                textAlign: "right",
              }}
            >
              Report Category Logo:
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={(event) => {
                handleReportCategoryLogoChange(event);
              }}
              style={{ width: "calc(100% - 220px)" }}
            />
          </div>

          {reportCategoryLogoUrl && (
            <div style={{ margin: "20px" }} className="text-center">
              <img
                src={reportCategoryLogoUrl || "/placeholder.svg"}
                alt="Report Logo Preview"
                style={{
                  maxWidth: "200px",
                  maxHeight: "200px",
                  objectFit: "contain",
                }}
              />
            </div>
          )}

          {/* Submit Button */}
          <div className="text-center" style={{ marginTop: "30px" }}>
            <Button
              style={{ padding: "9px 70px" }}
              type="submit"
              variant="contained"
              color="primary"
              className="table-row-background"
            >
              Submit
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ViewJobCriteriaBusiness;
